import { Expose } from "class-transformer";

export class UpdateReportTemplateDto {
  @Expose()
  name?: string;

  @Expose()
  active?: boolean;

  @Expose()
  interventionId?: string;

  @Expose()
  clientGroupId?: string;

  @Expose()
  templateId?: string;
}
